import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import moment from 'moment';
import { fetchSchoolEmployeesService } from 'actions/admin/employees';
import { fetchEmployeeCoursesService } from 'actions/admin/courses.js';
import Select from 'react-select';
import { Box, Paper, Tab, Tabs } from '@material-ui/core';
import SchoolIcon from '@material-ui/icons/School';
import PersonPinIcon from '@material-ui/icons/PersonPin';
// import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import constants, { courseStatic, employeeStatic } from '../../../config/constants.js';

import { fetchCurrentBatchByYearService } from '../../../actions/admin/batches.js';
import {
  formResMessage,
  formStudentSelectList,
  getCurrentYearBatchUtils,
  getGlobalCurrentBatchUtils,
  getGlobalSchoolUtils,
} from '../../../utils/commonFunc.js';
import { isLapView, store } from '../../../index.js';
import { showToast } from '../../../actions/admin/auth.js';
import EmpActivityFilter from '../EmployeeActivities/components/EmpActivityFilter.jsx';
import { fetchReportService } from '../../../actions/admin/reports.js';
import { fetchSchoolCourseStudentsService } from '../../../actions/admin/students.js';
import { fetchMyExamsService } from '../../../actions/admin/marks.js';
import CustomButton from '../../../components/CustomButton.jsx';
import { passEmployeeIdToStore } from '../EmployeeActivities/components/EmpActivityFilter.jsx';
import { passCourseIdToStore } from '../EmployeeActivities/components/EmpActivityFilter.jsx';
import CustomSelect from 'components/CustomSelect.jsx';
import colors from 'config/colors.js';
import ScheduleIcon from '@material-ui/icons/Schedule';
import EventIcon from '@material-ui/icons/Event';
import ReceiptIcon from '@material-ui/icons/Receipt';
import GroupIcon from '@material-ui/icons/Group';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import AssessmentIcon from '@material-ui/icons/Assessment';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import PersonIcon from '@material-ui/icons/Person';
import AssignmentIcon from '@material-ui/icons/Assignment';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import WorkIcon from '@material-ui/icons/Work';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const tabList = [
  { tabIndex: 0, tabTitle: 'School', query: 'school-report', icon: <SchoolIcon /> },
  {
    tabIndex: 1,
    tabTitle: `${courseStatic} Students`,
    query: 'batch-course-students-reports',
    icon: <SupervisorAccountIcon />,
  },
  { tabIndex: 2, tabTitle: 'Student', query: 'student-report', icon: <PersonPinIcon /> },
  { tabIndex: 3, tabTitle: employeeStatic, query: 'employee-report', icon: <AccountCircleIcon /> },
  // { tabIndex: 4, tabTitle: 'EXAMS & MARKS', query: 'exam-reports', icon: <LibraryAddCheckIcon /> },
];

export const selectStyle = fieldValue => {
  return {
    control: styles => {
      return {
        ...styles,
        borderColor: !fieldValue ? 'red' : styles?.borderColor,
      };
    },
  };
};

export function ScrollTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

class ReportsPage extends React.Component {
  constructor() {
    super();
    this.state = {
      schoolId: 0,
      employeeId: 0,
      courseId: 0,
      selectedDate: new Date(),
      activeTab: 0,
      assignmentPageParams: {
        page: 1,
        size: 10,
      },
      studentId: 0,
      examTypeDetailId: 0,
      isLoading: false,
      // New flow
      apiName: '',
      method: '',
      callback: '',
      reportLabel: '',
    };
  }

  componentDidMount() {
    const {
      location: { search },
      loggedUserId,
      loggedUserRole,
    } = this.props;
    if (search) {
      const cTab = tabList.find(dto => search.includes(dto.query));
      if (cTab) {
        this.toggleActivityTab(cTab.tabIndex);
      } else {
        this.toggleActivityTab(0);
      }
    } else {
      this.toggleActivityTab(0);
    }

    const globalSchool = getGlobalSchoolUtils();
    const schoolId = globalSchool?.schoolId || null;
    if (schoolId) {
      this.setState({ schoolId }, () => {
        if (loggedUserRole === constants.roles.SA || loggedUserRole === constants.roles.admin) {
          this.fetchAllEmployees();
        } else if (loggedUserRole === constants.roles.teacher) {
          this.fetchEmployeeCourses(loggedUserId);
        }
      });
    } else {
      this.showWarning('Please select school', 'warning');
    }
  }

  fetchCourseStudents = (passCourseId, isSelectChange) => {
    const courseId = passCourseId || this.props.storeCourseId;
    const { batchId } = getGlobalCurrentBatchUtils();
    if (courseId) {
      this.setState({ courseId });
      if (!this.props.courseStudentList?.length || isSelectChange) {
        this.props
          .fetchCourseStudents({
            courseId,
            batchId,
            token: this.props.loggedUserToken,
          })
          .then(students => {
            if (students?.length) {
              this.setState({ studentId: students?.[0]?.studentId });
            }
          });
      }
      this.props
        .fetchCourseExams({
          courseId,
          batchId,
          token: this.props.loggedUserToken,
        })
        .then(exams => {
          if (exams?.length) {
            this.setState({ examTypeDetailId: exams?.[0]?.examTypeDetailId });
          }
        });
      const { startYear, endYear } = getCurrentYearBatchUtils();
      if (!batchId && this.state.schoolId) {
        this.props.fetchCurrentBatch({
          courseId,
          startYear,
          endYear,
          token: this.props.loggedUserToken,
          schoolId: this.state.schoolId,
        });
      }
    }
  };

  fetchEmployeeCourses = async (employeeId, isSelectChange) => {
    const { batchId } = getGlobalCurrentBatchUtils();
    if (employeeId) {
      this.setState({
        employeeId,
        ...(isSelectChange && { courseId: 0 }),
      });
      if (batchId) {
        const courseList =
          !this.props.empCourseList?.length || isSelectChange
            ? await this.props.fetchEmployeeCourses({
                employeeId,
                batchId,
                token: this.props.loggedUserToken,
              })
            : this.props.empCourseList;
        if (courseList?.length) {
          const { courseId } = courseList[0];
          if (courseId && courseId !== this.props.storeCourseId) {
            passCourseIdToStore(courseId);
          }
          this.setState(prevState => ({
            ...prevState,
            courseId,
          }));
        } else {
          passCourseIdToStore(0);
        }
      }
    } else if (isSelectChange) {
      this.setState({
        employeeId: 0,
        courseId: 0,
      });
      passEmployeeIdToStore(0);
      passCourseIdToStore(0);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.storeEmployeeId !== this.props.storeEmployeeId) {
      this.fetchEmployeeCourses(this.props.storeEmployeeId, true);
      this.setState({ employeeId: this.props.storeEmployeeId });
    }

    if (prevProps.storeCourseId !== this.props.storeCourseId) {
      this.fetchCourseStudents(this.props.storeCourseId, true);
      this.setState({ courseId: this.props.storeCourseId, studentId: 0 });
    }
  }

  fetchAllEmployees = async () => {
    const employeeList = !this.props.schoolEmployeeList?.length
      ? await this.props.fetchAllEmployees({
          schoolId: this.state.schoolId,
          token: this.props.loggedUserToken,
          pageParams: this.state.assignmentPageParams,
        })
      : this.props.schoolEmployeeList;
    if (Array.isArray(employeeList) && employeeList?.length) {
      const { employeeId } = employeeList[0];
      if (!this.props.storeEmployeeId && employeeId) {
        passEmployeeIdToStore(employeeId);
        passCourseIdToStore(0);
      }
      this.fetchEmployeeCourses(employeeId);
      this.setState(prevState => ({
        ...prevState,
        employeeId: this.state.employeeId || employeeId,
        courseId: this.state.courseId || 0,
      }));
    }
  };

  showWarning = (message, type) => {
    this.setState({
      confirmModalOpen: false,
      assignConfirmModalOpen: false,
    });
    store.dispatch(showToast(message, type));
  };

  toggleActivityTab = tabIndex => {
    if (this.state.activeTab !== tabIndex) {
      this.setState({ activeTab: tabIndex, apiName: '', method: '', callback: '', reportLabel: '' });
      const cTab = tabList.find(dto => dto.tabIndex === tabIndex);
      this.props.history.push(`${this.props.location.pathname}?${cTab?.query}`);
      if (tabIndex === 2 || tabIndex === 4) {
        this.fetchCourseStudents(this.state.courseId, true);
      }
    }
  };

  setLoading = (value, apiName) => {
    this.setState(prevState => ({ ...prevState, isLoading: value, ...(apiName && { apiName }) }));
  };

  fetchReport = async passData => {
    this.setLoading(true, passData?.apiName);
    try {
      await this.props.fetchReport({
        ...passData,
      });
      this.setLoading(false);
    } catch (err) {
      this.setLoading(false);
      this.showWarning(formResMessage(err), 'error');
    }
  };

  fetchBatchReport = (apiName, reportName) => {
    const { batchId } = getGlobalCurrentBatchUtils();
    const globalSchool = getGlobalSchoolUtils();
    const schoolId = globalSchool?.schoolId || null;
    const { loggedUserSchool = schoolId, loggedUserToken } = this.props;
    if (batchId) {
      this.fetchReport({
        apiName,
        batchId,
        schoolId: loggedUserSchool,
        token: loggedUserToken,
        reportName,
      });
    }
  };

  fetchCourseReport = (apiName, reportName) => {
    const courseId = this.state.courseId || this.props.storeCourseId;
    const { batchId } = getGlobalCurrentBatchUtils();
    const globalSchool = getGlobalSchoolUtils();
    const schoolId = globalSchool?.schoolId || null;
    const { loggedUserSchool = schoolId, loggedUserToken } = this.props;
    if (courseId) {
      this.fetchReport({
        apiName,
        courseId,
        batchId,
        schoolId: loggedUserSchool,
        token: loggedUserToken,
        reportName,
      });
    }
  };

  getSelectStudent = studentId => {
    const existItem = this.props.courseStudentList?.find(item => item.studentId === studentId);
    if (existItem) {
      return {
        value: existItem.studentId,
        label: `${existItem.firstName} ${existItem.lastName}`,
      };
    }
    return null;
  };

  getSelectExam = examTypeDetailId => {
    const existItem = this.props.courseExams?.find(item => item.examTypeDetailId === examTypeDetailId);
    if (existItem) {
      const examDate = moment(existItem.examDate).format('LL');
      return {
        value: existItem.examTypeDetailId,
        label: `${existItem.examTitle} (${examDate.toString()})`,
      };
    }
    return null;
  };

  handleSelectChange = async (name, id) => {
    this.setState({ ...this.state, [name]: id });
  };

  fetchStudentReport = (apiName, reportName) => {
    const globalSchool = getGlobalSchoolUtils();
    const schoolId = globalSchool?.schoolId || null;
    const { loggedUserSchool = schoolId, storeCourseId } = this.props;
    const courseId = this.state.courseId || storeCourseId;
    const { studentId } = this.state;
    const { batchId } = getGlobalCurrentBatchUtils();
    if (courseId && studentId) {
      this.fetchReport({
        schoolId: loggedUserSchool,
        apiName,
        courseId,
        studentId,
        batchId,
        token: this.props.loggedUserToken,
        reportName,
      });
    }
  };

  fetchSchoolReport = (apiName, reportName) => {
    const courseId = this.state.courseId || this.props.storeCourseId;
    const { batchId } = getGlobalCurrentBatchUtils();
    const globalSchool = getGlobalSchoolUtils();
    const schoolId = globalSchool?.schoolId || null;
    const { loggedUserSchool = schoolId, loggedUserToken } = this.props;
    if (loggedUserSchool && batchId && courseId) {
      this.fetchReport({
        apiName,
        courseId,
        batchId,
        schoolId: loggedUserSchool,
        token: loggedUserToken,
        reportName,
      });
    }
  };

  fetchEmployeeReport = (apiName, reportName) => {
    const { employeeId } = this.state;
    if (employeeId) {
      this.fetchReport({
        apiName,
        employeeId,
        token: this.props.loggedUserToken,
        reportName,
      });
    }
  };

  fetchExamReport = (apiName, reportName) => {
    const { examTypeDetailId, studentId } = this.state;
    if (examTypeDetailId && studentId) {
      this.fetchReport({
        method: apiName === 'getCourseProgressReport' ? 'GET' : 'POST',
        apiName,
        examTypeDetailId,
        studentId,
        token: this.props.loggedUserToken,
        reportName,
      });
    }
  };

  fetchMarkReport = apiName => {
    this.fetchReport({
      apiName,
      token: this.props.loggedUserToken,
    });
  };

  handleCheckChange = (actionObj = {}) => {
    this.setState(prevState => ({
      ...prevState,
      ...actionObj,
    }));
  };

  generateReport = e => {
    e.preventDefault();
    const { apiName, reportLabel, callback } = this.state;
    if (apiName && reportLabel && callback) {
      if (typeof callback === 'function') {
        callback?.(apiName, reportLabel);
      }
    }
  };

  render() {
    const { activeTab, studentId, examTypeDetailId, apiName, isLoading, reportLabel } = this.state;
    const {
      loggedUserRole,
      schoolEmployeeList,
      empCourseList,
      courseStudentList,
      courseExams,
      storeEmployeeId,
      storeCourseId,
    } = this.props;

    // Report-type card: icon + label + one-line description of what the report contains, laid
    // out in a grid instead of a flat radio row or a bare pill chip, so this reads as a report
    // builder rather than a plain form.
    const reportOptionCard = el => {
      const nameOrValue = el?.apiName;
      const checked = apiName === nameOrValue;
      const busy = checked && isLoading;
      const Icon = el?.icon || AssessmentIcon;
      return (
        <div
          key={nameOrValue}
          onClick={() => !busy && this.handleCheckChange(el)}
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 12,
            padding: 14,
            borderRadius: 10,
            border: `1.5px solid ${checked ? colors.accent : '#e0e0e0'}`,
            backgroundColor: checked ? '#F5EDFB' : '#fff',
            cursor: busy ? 'default' : 'pointer',
            textAlign: 'left',
          }}>
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              backgroundColor: checked ? colors.accent : '#F0EDF4',
              color: checked ? '#fff' : colors.accentDark,
            }}>
            <Icon fontSize="small" />
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 'bold', color: checked ? colors.accent : '#3d4f43' }}>
              {el.reportLabel}
            </div>
            {el.desc && <div style={{ fontSize: 11, color: '#8a94a6', marginTop: 2 }}>{el.desc}</div>}
          </div>
          {checked && (
            <CheckCircleIcon
              fontSize="small"
              style={{ position: 'absolute', top: 8, right: 8, color: colors.accent }}
            />
          )}
        </div>
      );
    };

    // Sits directly under each tab's own card grid (not one shared button floating below every
    // panel) and names the selected report, so it's clear what Generate is about to produce
    // without scrolling back up to see which card is highlighted.
    const generateActionBar = (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 10,
          padding: '12px 16px',
          borderTop: '1px solid #eee',
        }}>
        <span style={{ fontSize: 12, color: '#8a94a6' }}>
          {reportLabel ? (
            <>
              Selected: <b style={{ color: colors.accent }}>{reportLabel}</b>
            </>
          ) : (
            'Pick a report above to continue'
          )}
        </span>
        <CustomButton
          onClick={this.generateReport}
          name="Generate Report"
          showLoader={true}
          disabled={isLoading || !apiName}
          loading={isLoading}
          style={{ backgroundColor: colors.accent, color: colors.white }}
        />
      </div>
    );

    return (
      <div className="content">
        <EmpActivityFilter
          activeTab={activeTab}
          loggedUserRole={loggedUserRole}
          employees={schoolEmployeeList}
          employeeId={storeEmployeeId}
          courseId={storeCourseId}
          courses={empCourseList}
          fetchEmployeeCourses={this.fetchEmployeeCourses}
          fetchCourseStudents={this.fetchCourseStudents}
        />
        <Paper square>
          <Tabs
            value={activeTab}
            onChange={(e, tabIndex) => this.toggleActivityTab(tabIndex)}
            indicatorColor=""
            textColor="inherit"
            variant={isLapView ? 'fullWidth' : 'scrollable'}
            scrollButtons="on"
            aria-label="scrollable force tabs example">
            {tabList.map((item, i) => {
              return (
                <Tab
                  key={i}
                  icon={item.icon}
                  label={item.tabTitle}
                  style={{
                    fontWeight: 'bold',
                    color: activeTab === item.tabIndex ? colors.accent : '',
                    borderBottom: activeTab === item.tabIndex ? `3px solid ${colors.accent}` : '',
                  }}
                />
              );
            })}
          </Tabs>
        </Paper>
        <ScrollTabPanel value={activeTab} index={0}>
          <br />
          <Card>
            <CardBody
              style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
              {[
                {
                  reportLabel: 'Time table',
                  desc: `Weekly period schedule for the selected ${courseStatic.toLowerCase()}`,
                  icon: ScheduleIcon,
                  apiName: 'generateCourseTimeTablePDFReport',
                  callback: this.fetchSchoolReport,
                },
                {
                  reportLabel: 'Holidays',
                  desc: 'School holiday calendar for the year',
                  icon: EventIcon,
                  apiName: 'generateHolidaCalendarPDFReport',
                  callback: this.fetchSchoolReport,
                },
                {
                  reportLabel: 'School Fee Structure',
                  desc: `Fee structure across every ${courseStatic.toLowerCase()} in the batch`,
                  icon: ReceiptIcon,
                  apiName: 'generateSchoolCourseFeesStructureReport',
                  callback: this.fetchSchoolReport,
                },
                {
                  reportLabel: `${courseStatic} Fee Structure`,
                  desc: `Fee structure for the selected ${courseStatic.toLowerCase()} only`,
                  icon: ReceiptIcon,
                  apiName: 'generateCourseFeesStructureReport',
                  callback: this.fetchSchoolReport,
                },
              ].map(el => {
                return reportOptionCard(el);
              })}
            </CardBody>
            {generateActionBar}
          </Card>
        </ScrollTabPanel>
        <ScrollTabPanel value={activeTab} index={1}>
          <br />
          <Card>
            <CardBody
              style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
              {[
                {
                  reportLabel: 'Current Batch Students',
                  desc: 'Name list of every student in the current batch',
                  icon: GroupIcon,
                  apiName: 'generateBatchStudentsPDFReport',
                  callback: this.fetchBatchReport,
                },
                {
                  reportLabel: `${courseStatic} Students`,
                  desc: `Name list of students in the selected ${courseStatic.toLowerCase()}`,
                  icon: PeopleOutlineIcon,
                  apiName: 'generateCourseStudentsPDFReport',
                  callback: this.fetchCourseReport,
                },
                {
                  reportLabel: 'Students Exam Marks',
                  desc: `Exam marks for every student in the ${courseStatic.toLowerCase()}`,
                  icon: AssessmentIcon,
                  apiName: 'generateCourseProgressPDFReport',
                  callback: this.fetchCourseReport,
                },
                {
                  reportLabel: 'Batch Students Attendance',
                  desc: 'Attendance record across the whole batch',
                  icon: EventAvailableIcon,
                  apiName: 'generateStudentsBatchAttendancePDFReport',
                  callback: this.fetchBatchReport,
                },
                {
                  reportLabel: `${courseStatic} Students Attendace`,
                  desc: `Attendance record for the selected ${courseStatic.toLowerCase()}`,
                  icon: EventAvailableIcon,
                  apiName: 'generateStudentsCourseAttendancePDFReport',
                  callback: this.fetchCourseReport,
                },
              ].map(el => {
                return reportOptionCard(el);
              })}
            </CardBody>
            {generateActionBar}
          </Card>
        </ScrollTabPanel>
        <ScrollTabPanel value={activeTab} index={2}>
          <br />
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label htmlFor="">
                  <strong>
                    {courseStatic} Student<sup> *</sup>
                  </strong>
                </Label>
                <CustomSelect
                  noLabel={true}
                  name="studentId"
                  onChange={this.handleSelectChange}
                  options={formStudentSelectList(courseStudentList)}
                  value={studentId}
                  applyLabelStyle={true}
                />
              </FormGroup>
            </Col>
          </Row>
          <Card>
            <CardBody
              style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
              {[
                {
                  reportLabel: 'Student Details',
                  desc: 'Full profile for the selected student',
                  icon: PersonIcon,
                  apiName: 'generateSimplePDFReport',
                  callback: this.fetchStudentReport,
                },
                {
                  reportLabel: 'Home work & Assignment',
                  desc: 'All homework and assignments given to this student',
                  icon: AssignmentIcon,
                  apiName: 'generateHomeworkPDFReport',
                  callback: this.fetchStudentReport,
                },
                {
                  reportLabel: 'Progress report',
                  desc: "This student's exam and academic progress",
                  icon: TrendingUpIcon,
                  apiName: 'generateStudentProgressPDFReport',
                  callback: this.fetchStudentReport,
                },
                {
                  reportLabel: 'Student Fee Structure',
                  desc: 'Fee structure and payment history for this student',
                  icon: ReceiptIcon,
                  apiName: 'generateStudentFeesStructureReport',
                  callback: this.fetchStudentReport,
                },
              ].map(el => {
                return reportOptionCard(el);
              })}
            </CardBody>
            {generateActionBar}
          </Card>
        </ScrollTabPanel>
        <ScrollTabPanel value={activeTab} index={3}>
          <br />
          <Card>
            <CardBody
              style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
              {[
                {
                  reportLabel: `${employeeStatic} Details`,
                  desc: `Full profile for the selected ${employeeStatic.toLowerCase()}`,
                  icon: WorkIcon,
                  apiName: 'generateEmployeePDFReport',
                  callback: this.fetchEmployeeReport,
                },
              ].map(el => {
                return reportOptionCard(el);
              })}
            </CardBody>
            {generateActionBar}
          </Card>
        </ScrollTabPanel>
        <ScrollTabPanel value={activeTab} index={4}>
          <br />
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label htmlFor="">
                  <strong>
                    {courseStatic} Exam<sup> *</sup>
                  </strong>
                </Label>
                <Select
                  name="examTypeDetailId"
                  onChange={value => this.handleSelectChange('examTypeDetailId', value.value)}
                  options={
                    courseExams
                      ? courseExams.map(item => {
                          const examDate = moment(item.examDate).format('LL');
                          return {
                            value: item.examTypeDetailId,
                            label: `${item.examTitle} (${examDate})`,
                          };
                        })
                      : null
                  }
                  value={this.getSelectExam(examTypeDetailId)}
                  // isLoading={!this.getSelectExam(examTypeDetailId)}
                  styles={selectStyle(this.getSelectExam(examTypeDetailId))}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label htmlFor="">
                  <strong>
                    {courseStatic} Student<sup> *</sup>
                  </strong>
                </Label>
                <CustomSelect
                  noLabel={true}
                  name="studentId"
                  onChange={this.handleSelectChange}
                  options={formStudentSelectList(courseStudentList)}
                  value={studentId}
                  applyLabelStyle={true}
                />
              </FormGroup>
            </Col>
          </Row>
          <Card>
            <CardBody
              style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
              {[
                {
                  reportLabel: 'Student Exam',
                  apiName: 'getStudentProgressReport',
                  callback: this.fetchExamReport,
                },
                {
                  reportLabel: 'Student Marks',
                  apiName: 'generateStudentProgressPDFReport',
                  callback: this.fetchStudentReport,
                },
              ].map(el => {
                return reportOptionCard(el);
              })}
            </CardBody>
            {generateActionBar}
          </Card>
        </ScrollTabPanel>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loggedUserId: state.auth.loggedUserId,
    loggedUserToken: state.auth.loggedUserToken,
    loggedUserRole: state.auth.loggedUserRole,
    loggedUserSchool: state.auth.loggedUserSchool || undefined,
    empCourseList: state.courses.empCourseList,
    courseStudentList: state.schools.courseStudentList,
    currentBatch: state.batches.currentBatch || {},
    courseExams: state.marks.myExamsList,
    schoolEmployeeList: state.employees.employeeList || [],
    storeEmployeeId: state.employees.storeEmployeeId,
    storeCourseId: state.employees.storeCourseId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllEmployees: data => dispatch(fetchSchoolEmployeesService(data)),
    fetchEmployeeCourses: data => dispatch(fetchEmployeeCoursesService(data)),
    fetchCourseStudents: data => dispatch(fetchSchoolCourseStudentsService(data)),

    fetchCurrentBatch: data => dispatch(fetchCurrentBatchByYearService(data)),
    // Exam
    fetchCourseExams: data => dispatch(fetchMyExamsService(data)),
    // Report
    fetchReport: data => dispatch(fetchReportService(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportsPage);
